<template>
  <div class="level">
    <qd-collapse class="column is-5 is-paddingless" >
      <div class="columns is-multiline is-marginless subMenu">
        <div class="column is-12 is-paddingless">
          <div class="level-right">
            <button @click="close()" class="button is-subMenu">
              <b-icon icon="close"
                      custom-size="mdi-10px"
                      type="is-white">
              </b-icon>
            </button>
          </div>
          <display-menu-and-sub-menu :menuAndSubMenu="patrimoine">
          </display-menu-and-sub-menu>
        </div>
      </div>
    </qd-collapse>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import displayMenuAndSubMenu from '@/components/sideBar/submenuSidebar/displayMenuAndSubMenu';
import {
  EMPLACEMENT,
  COLLECTIVITE,
  CONFRERE,
  MATERIEL_TLPE,
  DECLARATION_TLPE,
  COMMANDE_TLPE,
  FOURNISSEUR_MATERIEL,
  TITRE_RECETTE,
  PAIEMENT_RECETTE,
  LOT_PAIEMENT_RECETTE,
  JOURNAL_PAIEMENT_RECETTE,
} from '@/configuration/gabed/permissionsGabedConf';
import {
  SET_INDEX_SUB_MENU_OPEN,
  SET_PATRIMOINE_MENU,
} from '@/store/modules/menu/menu-mutation-type';

const menu = createNamespacedHelpers('menu');

export default {
  name: 'SidebarPatrimoine',
  components: {
    displayMenuAndSubMenu,
  },
  data() {
    return {
      patrimoine: [
        {
          title: 'sidebar.patrimoine.emplacement',
          noSubMenu: false,
          data: [
            {
              name: 'sidebar.patrimoine.emplacement',
              path: 'l.gabed.emplacement',
              perm: EMPLACEMENT.lecture,
              params: { activeTab: 'emplacement' },
            },
            {
              name: 'sidebar.patrimoine.dispositif',
              path: 'l.gabed.emplacement',
              perm: EMPLACEMENT.lecture,
              params: { activeTab: 'dispositif' },
            },
            {
              name: 'sidebar.patrimoine.materiel',
              path: 'l.gabed.emplacement',
              perm: EMPLACEMENT.lecture,
              params: { activeTab: 'materiel' },
            },
            {
              name: 'sidebar.patrimoine.face',
              path: 'l.gabed.emplacement',
              perm: EMPLACEMENT.lecture,
              params: { activeTab: 'face' },
            },
          ],
        },
        {
          title: 'sidebar.patrimoine.tlpe',
          noSubMenu: false,
          data: [
            {
              name: 'sidebar.patrimoine.collectivite',
              path: 'l.gabed.collectivite',
              perm: COLLECTIVITE.lecture,
            },
            {
              name: 'sidebar.patrimoine.materielTlpe',
              path: 'l.gabed.materielTlpe',
              perm: MATERIEL_TLPE.lecture,
              params: { activeTab: 'materielTlpe' },
            },
            {
              name: 'sidebar.patrimoine.declaration',
              path: 'l.gabed.declarationTlpe',
              perm: DECLARATION_TLPE.lecture,
            },
            {
              name: 'sidebar.patrimoine.declarationAuFilDeLeau',
              path: 'l.gabed.declarationTlpe-AuFilDeLeau',
              perm: DECLARATION_TLPE.lecture,
            },
            {
              name: 'sidebar.patrimoine.commandeTlpe',
              path: 'l.gabed.commande_tlpe',
              perm: COMMANDE_TLPE.lecture,
            },
            {
              name: 'sidebar.patrimoine.titreRecette',
              path: 'l.gabed.titre_recette',
              perm: TITRE_RECETTE.lecture,
            },
            {
              name: 'sidebar.patrimoine.paiement',
              path: 'l.gabed.paiement_recette',
              perm: PAIEMENT_RECETTE.lecture,
            },
            {
              name: 'sidebar.patrimoine.lotPaiement',
              path: 'l.gabed.lot_paiement_recette',
              perm: LOT_PAIEMENT_RECETTE.lecture,
            },
            {
              name: 'sidebar.patrimoine.JournalPaiement',
              path: 'l.gabed.journal_paiement_recette',
              perm: JOURNAL_PAIEMENT_RECETTE.lecture,
            },
          ],
        },
        {
          title: 'sidebar.patrimoine.confrere',
          path: 'l.gabed.confrere',
          noSubMenu: true,
          perm: CONFRERE.lecture,
        },
        {
          title: 'sidebar.patrimoine.fournisseurMateriel',
          path: 'l.gabed.fournisseur_materiel',
          noSubMenu: true,
          perm: FOURNISSEUR_MATERIEL.lecture,
        },
      ],
    };
  },
  methods: {
    ...menu.mapMutations({
      setPatrimoineMenu: SET_PATRIMOINE_MENU,
      setIndexSubMenu: SET_INDEX_SUB_MENU_OPEN,
    }),
    close() {
      this.setPatrimoineMenu(false);
      this.setIndexSubMenu(null);
    },
  },
};
</script>

<style scoped>

</style>
